<template>
	<b-container fluid class="h-100 imagem-fundo">
		<b-row align-h="center" align-v="center" class="h-100 p-0">
			<b-col sm="6" lg="4" md="6" xl="3" class="bg-white rounded shadow">
				<b-row align-h="center" class="my-3">
					<b-col class="text-center">
						<h4>Acesse o sistema</h4>
						<hr />
					</b-col>
				</b-row>
				<b-row>
					<b-col class="text-center pb-4 px-4">
						<b-img
							:src="`logo-${ug}.png`"
							fluid
							alt="Logo HUWC"
						></b-img>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-input
							placeholder="Usuário"
							v-model.trim="username"
							aria-describedby="usuario-erro"
							:state="$v.username.$error ? false : null"
							:autofocus="true"
							ref="username"
							>></b-form-input
						>
						<b-form-invalid-feedback id="usuario-erro"
							>Este campo é obrigatório.</b-form-invalid-feedback
						>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col>
						<b-input-group>
							<b-form-input
								:type="exibe_password ? 'text' : 'password'"
								placeholder="Senha"
								v-model="password"
								aria-describedby="senha-erro"
								@keyup.enter="submit"
								:state="$v.password.$error ? false : null"
							></b-form-input>
							<b-input-group-prepend is-text>
								<a
									@click.prevent="
										exibe_password = !exibe_password
									"
									><b-icon
										:icon="
											exibe_password ? 'eye' : 'eye-slash'
										"
									></b-icon
								></a>
							</b-input-group-prepend>
						</b-input-group>
						<b-form-invalid-feedback id="senha-erro"
							>Este campo é obrigatório.</b-form-invalid-feedback
						>
					</b-col>
				</b-row>

				<b-row class="mb-3">
					<b-col>
						<b-button
							block
							variant="success"
							@click.prevent="submit"
							class="mt-3"
							>Entrar</b-button
						>
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col>
						<b-alert variant="danger" :show="error">{{
							errorMessage
						}}</b-alert>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<small>
							<span class="text-danger mr-1"
								>Primeiro acesso?</span
							>
							<b-link to="usuario/cadastro"
								>Cadastre aqui seu usuário!</b-link
							>
						</small>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<small>
							Clique
							<a :href="link_cardapio" target="_blank">aqui</a>
							para acessar o <strong>cardápio da semana</strong>.
						</small>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<small>
							Clique
							<a
								href="https://redcap.link/reservaficar"
								target="_blank"
								>aqui</a
							>
							para acessar o formulário de
							<strong>reserva de refeição </strong>.
						</small>
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col>
						<small>
							Clique
							<a
								href="https://redcap.huwc.ufc.br/surveys/?s=YL8TANMERAY7N3AT"
								target="_blank"
								>aqui</a
							>
							para solicitar
							<strong>refeições da emergência MEAC</strong>.
						</small>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
	data() {
		return {
			username: "",
			password: "",
			error: false,
			errorMessage: "",
			ug: null,
			link_cardapio: null,
			exibe_password: false,
		};
	},
	validations: {
		username: {
			required,
		},
		password: {
			required,
		},
	},
	methods: {
		get_url_cardapio() {
			this.$http.get("/configuracoes/5").then((c) => {
				this.link_cardapio = c.data.valor_texto;
			});
		},
		submit() {
			this.$v.$touch();
			if (this.$v.$anyError) {
				return false;
			} else {
				this.$http
					.post("/login", {
						username: this.username,
						password: this.password,
					})
					.then((res) => {
						//console.log(res);
						if (res.data.auth == true) {
							this.$session.start();
							this.$session.set("jwt", res.data.token);
							this.$http.defaults.headers.common[
								"Authorization"
							] = "bearer " + res.data.token;
							this.$store.commit(
								"setLoggedUser",
								res.data.userdata
							);
							this.$store.commit(
								"setPermissions",
								res.data.permissoes
							);

							localStorage.setItem(
								"__" +
									process.env.VUE_APP_CI_PROJECT_NAME +
									"_app",
								JSON.stringify(res.data)
							);
							this.$router.push("/inicio");
						} else {
							this.error = true;
							this.errorMessage = res.data.message;
						}
					})
					.catch(() => {
						this.error = true;
						this.$refs.username.focus();
					});
			}
		},
	},
	mounted() {
		//this.ug = process.env.VUE_APP_UG;
		this.get_url_cardapio();
	},
	created() {
		this.ug = process.env.VUE_APP_UG;
	},
};
</script>

<style>
.imagem-fundo {
	background-image: url("../assets/fundo-pagina-login.jpg");
	background-size: cover;
}
a {
	cursor: pointer;
}
</style>
